<mat-stepper
        class="invoice-stepper-form"
        #stepper
        [linear]="true"
        (selectionChange)="preventFormValidation($event, stepper);">
            <mat-step [completed]="invoiceFormSearch.valid">
                <ng-template matStepLabel>Invoice Search</ng-template>
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <modal-panel
                            data-testid="Set Invoice"
                            class="filter-panel"
                            title="Set New Invoice"
                            (close)="closeModal();">
                                <div data-testid="invoice-form-selector" class="filter__fields">
                                    <form [formGroup]="invoiceFormSearch" (submit)="nextInvoiceFormSelector()">
                                        <mat-form-field>
                                            <mat-label>Search Trip</mat-label>
                                            <input
                                                matInput
                                                placeholder="1234"
                                                formControlName="tripId"
                                                type="number"
                                                (input)="clearSelectorFormFields('tripModel')">
                                                @if(invoiceFormSearch.controls['tripModel'].value){
                                                    <button
                                                        data-testid="invoice-form-trip-id-search-button"
                                                        matSuffix mat-icon-button
                                                        type="button"
                                                        title="Trip found"
                                                        disabled>
                                                            <mat-icon>check</mat-icon>
                                                    </button>
                                                }
                                                @if(invoiceFormSearch.controls['tripId'].value && !tripData){
                                                    <button
                                                        data-testid="invoice-form-trip-id-clear-button"
                                                        matSuffix mat-icon-button
                                                        type="button"
                                                        title="Clear trip"
                                                        (click)="clearSelectorFormFields('tripId', 'tripModel')">
                                                            <mat-icon>close</mat-icon>
                                                    </button>
                                                }
                                                @if (invoiceFormSearch.controls['tripId'].hasError('required')) {
                                                    <mat-error>Trip is <strong>required</strong></mat-error>
                                                }
                                                @if (invoiceFormSearch.controls['tripId'].hasError('tripNotFound')) {
                                                    <mat-error>Trip <strong>not found</strong></mat-error>
                                                }
                                        </mat-form-field>

                                        @if(invoiceFormSearch.controls['tripModel'].value){
                                            <mat-radio-group formControlName="isNew">
                                                <mat-radio-button [value]="false" [disabled]="hasNoInvoices()" title="Copy invoice">Copy of existing invoice</mat-radio-button>
                                                <mat-radio-button [value]="true" title="New invoice">New Invoice</mat-radio-button>
                                            </mat-radio-group>

                                            @if(!invoiceFormSearch.controls['isNew'].value){
                                                <mat-form-field>
                                                    <mat-label>Invoice</mat-label>
                                                    <input type="text"
                                                        placeholder="Pick One"
                                                        aria-label="Invoice"
                                                        matInput
                                                        formControlName="invoice"
                                                        [matAutocomplete]="auto">
                                                    @if(invoiceFormSearch.controls['invoice'].value){
                                                        <button
                                                            data-testid="invoice-form-invoice-clear-button"
                                                            matSuffix mat-icon-button
                                                            type="button"
                                                            title="Clear invoice"
                                                            (click)="clearSelectorFormFields('invoice')">
                                                                <mat-icon>close</mat-icon>
                                                        </button>
                                                    }
                                                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWithInvoice">
                                                        @for (invoiceOption of filteredInvoicesOptions$ | async; track invoiceOption?.id) {
                                                            <mat-option [value]="invoiceOption">{{invoiceOption?.id}}</mat-option>
                                                        }
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            }

                                            @if(invoiceFormSearch.controls['isNew'].value){
                                                @let tramsDataSourceOptions = tramsDataSourceList$ | async;
                                                <mat-form-field>
                                                    <mat-label>Data Source</mat-label>
                                                    <mat-select formControlName="dataSourceId">
                                                        @for (dataSource of tramsDataSourceOptions; track dataSource?.id) {
                                                            <mat-option [value]="dataSource?.id">{{dataSource?.sourceName}}</mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                            }
                                        }
                                    </form>
                                    @if (invoiceFormSearch.controls['invoice'].value){
                                        <button
                                            color="primary"
                                            mat-stroked-button
                                            (click)="completeInvoiceFormCopy()"
                                            type="button">
                                                Create Invoice
                                        </button>
                                    }
                                    @else {
                                        <button
                                            color="primary"
                                            mat-stroked-button
                                            (click)="nextInvoiceFormSelector()"
                                            type="button"
                                            [disabled]="!canCreateNewInvoice()"
                                            [title]="canCreateNewInvoice() ? 'Next step' : 'Cannot create invoice - no datasource available for this trip'"
                                            [matTooltip]="canCreateNewInvoice() ? '' : 'Cannot create invoice - no datasource available for this trip'"
                                            matTooltipPosition="above">
                                                Next
                                        </button>
                                    }
                                </div>
                        </modal-panel>
                    </mat-card-content>
                </mat-card>
            </mat-step>

            <mat-step>
                <ng-template matStepLabel>Invoice Create</ng-template>
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <modal-panel
                        data-testid="Create Invoice"
                        class="filter-panel"
                        title="Create New Invoice"
                        (close)="closeModal();">
                            <form [formGroup]="invoiceFormCreate" (submit)="completeInvoiceFormCreate()">
                                <div class="filter__fields two-col-grid">
                                    <div class="one">
                                        <profile-autocomplete
                                            autocompleteMode="I"
                                            [dataSourceId]=""
                                            [hideClearButton]="isPreselectedCreate()"
                                            formControlName="profile"/>

                                        <mat-form-field>
                                            <mat-label>Record Locator</mat-label>
                                            <input
                                                upperCase
                                                matInput
                                                placeholder="ABC123"
                                                formControlName="recordLocator">
                                                @if(invoiceFormCreate.controls['recordLocator'].value && !invoiceFormCreate.controls['recordLocator'].disabled){
                                                    <button
                                                        data-testid="invoice-form-record-locator-clear-button"
                                                        matSuffix mat-icon-button
                                                        type="button"
                                                        title="Clear record locator"
                                                        (click)="clearCreateFormFields('recordLocator')">
                                                            <mat-icon>close</mat-icon>
                                                    </button>
                                                }
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Remarks</mat-label>
                                            <input
                                                matInput
                                                placeholder="Remarks"
                                                formControlName="remarks">
                                                @if(invoiceFormCreate.controls['remarks'].value){
                                                    <button
                                                        data-testid="invoice-form-remarks-clear-button"
                                                        matSuffix mat-icon-button
                                                        type="button"
                                                        title="Clear remarks"
                                                        (click)="clearCreateFormFields('remarks')">
                                                            <mat-icon>close</mat-icon>
                                                    </button>
                                                }
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Total Amount</mat-label>
                                            <input
                                                matInput
                                                placeholder="Amount"
                                                formControlName="amount"
                                                type="number"
                                                (keypress)="checkInputAmount($event)">
                                                @if(invoiceFormCreate.controls['amount'].value){
                                                    <button
                                                        data-testid="invoice-form-amount-clear-button"
                                                        matSuffix mat-icon-button
                                                        type="button"
                                                        title="Clear amount"
                                                        (click)="clearCreateFormFields('amount')">
                                                            <mat-icon>close</mat-icon>
                                                    </button>
                                                }
                                        </mat-form-field>
                                    </div>
                                    <div class="two">
                                        <mat-form-field>
                                            <mat-label>Branch</mat-label>
                                            <input
                                                type="text"
                                                matInput
                                                formControlName="branch"
                                                [matAutocomplete]="branchAuto">
                                                <mat-autocomplete #branchAuto="matAutocomplete" [displayWith]="displayWithBranch">
                                                    @for (branch of filteredBranch$ | async; track branch?.id) {
                                                        <mat-option [value]="branch">{{branch?.name}}</mat-option>
                                                    }
                                                </mat-autocomplete>
                                                @if(!isPreselectedCreate() && invoiceFormCreate.controls['branch'].value){
                                                    <button
                                                        data-testid="invoice-form-branch-clear-button"
                                                        matSuffix mat-icon-button
                                                        type="button"
                                                        title="Clear branch"
                                                        (click)="clearCreateFormFields('branch')">
                                                            <mat-icon>close</mat-icon>
                                                    </button>
                                                }
                                        </mat-form-field>

                                        @let invoiceTypeOptions = invoiceTypeList$ | async;
                                        <mat-form-field>
                                            <mat-label>Invoice Type</mat-label>
                                            <mat-select formControlName="invoiceType" (selectionChange)="onInvoiceTypeChange($event.value)">
                                            @for (invoicetype of invoiceTypeOptions; track invoicetype?.id) {
                                                <mat-option [value]="invoicetype?.invoiceTypeCode">{{invoicetype?.invoiceTypeName}}</mat-option>
                                            }
                                            </mat-select>
                                            @if(invoiceFormCreate.controls['invoiceType'].value){
                                                <button
                                                    data-testid="invoice-form-invoice-type-clear-button"
                                                    matSuffix mat-icon-button
                                                    type="button"
                                                    title="Clear invoice type"
                                                    (click)="clearCreateFormFields('invoiceType'); $event.stopPropagation()">
                                                        <mat-icon>close</mat-icon>
                                                </button>
                                            }
                                        </mat-form-field>

                                        <mat-form-field>
                                            <mat-label>Invoice Group</mat-label>
                                            <input
                                                matInput
                                                placeholder="Invoice Group"
                                                formControlName="invoiceGroup">
                                            @if(invoiceFormCreate.controls['invoiceGroup'].value){
                                                <button
                                                    data-testid="invoice-form-invoice-group-clear-button"
                                                    matSuffix mat-icon-button
                                                    type="button"
                                                    title="Clear invoice group"
                                                    (click)="clearCreateFormFields('invoiceGroup')">
                                                        <mat-icon>close</mat-icon>
                                                </button>
                                            }
                                        </mat-form-field>

                                        <mat-form-field>
                                            <mat-label>Currency</mat-label>
                                            <input
                                                type="text"
                                                matInput
                                                formControlName="currency"
                                                [matAutocomplete]="currencyAuto">
                                                <mat-autocomplete #currencyAuto="matAutocomplete" [displayWith]="displayWithCurrencyList">
                                                    @for (currency of filteredCurrency$ | async; track currency?.id) {
                                                        <mat-option [value]="currency">
                                                            {{currency?.currencyName}} {{currency?.symbol ? '('+currency?.symbol+')' : ''}}
                                                        </mat-option>
                                                    }
                                                </mat-autocomplete>
                                                @if(invoiceFormCreate.controls['currency'].value){
                                                    <button
                                                        data-testid="invoice-form-currency-clear-button"
                                                        matSuffix mat-icon-button
                                                        type="button"
                                                        title="Clear currency"
                                                        (click)="clearCreateFormFields('currency')">
                                                            <mat-icon>close</mat-icon>
                                                    </button>
                                                }
                                        </mat-form-field>
                                        @if(isPreselectedCreate()){
                                            @let tramsDataSourceOptions = tramsDataSourceList$ | async;
                                            <mat-form-field>
                                                <mat-label>Data source</mat-label>
                                                <mat-select formControlName="dataSourceId">
                                                    @for (dataSource of tramsDataSourceOptions; track dataSource?.id) {
                                                        <mat-option [value]="dataSource?.id">{{dataSource?.sourceName}}</mat-option>
                                                    }
                                                </mat-select>
                                                @if(!isPreselectedCreate() && invoiceFormCreate.controls['dataSourceId'].value){
                                                    <button
                                                        data-testid="invoice-form-data-source-id-clear-button"
                                                        matSuffix mat-icon-button
                                                        type="button"
                                                        title="Clear data source"
                                                        (click)="clearCreateFormFields('dataSourceId'); $event.stopPropagation()">
                                                            <mat-icon>close</mat-icon>
                                                    </button>
                                                }
                                            </mat-form-field>
                                        }

                                    </div>
                                </div>

                                <button
                                    color="primary"
                                    mat-stroked-button
                                    type="submit"
                                    [disabled]="invoiceFormCreate.invalid">
                                        Create Invoice
                                </button>
                            </form>
                        </modal-panel>
                    </mat-card-content>
                </mat-card>
                <button
                    color="primary"
                    mat-stroked-button
                    matStepperPrevious
                    title="Previous step"
                    (click)="returnInvoiceFormCreate()"
                    type="button">
                        Back
                </button>
            </mat-step>
</mat-stepper>
